export default __webpack_public_path__ + "static/media/MAXIS_2.fca8eee2.gif";